var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.preventDefault)?_c('a',{on:{"click":_vm.clickHref}},[_vm._t("default")],2):_c('nuxt-link',{attrs:{"to":_vm.link}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }